module.exports = __webpack_public_path__ + "img/filezilla.296994a9.svg";